import styled from '@emotion/styled';
import { sdsColor, sdsRadius } from '@staging-design-system';
import { rem } from '@utils';

const Card = styled.span`
  display: block;
  margin: ${rem(24)} 0;
  border: 1px solid ${sdsColor.border.defaultDefault};
  border-radius: ${sdsRadius.medium};
  color: ${sdsColor.text.defaultDefault};
  width: 100%;
  overflow: hidden;
`;

const Skeleton = styled.span`
  display: block;
  background: ${sdsColor.background.defaultSecondary};
  border: 1px solid ${sdsColor.border.defaultDefault};
  border-radius: ${sdsRadius.medium};
  height: ${rem(48)};
  width: 100%;
  margin: ${rem(24)} 0;
`;

const ErrorText = styled.span`
  color: ${sdsColor.text.defaultSecondary};
  display: block;
  font-size: ${rem(13)};
  margin: ${rem(16)} 0;
  text-align: center;
`;

const Header = styled.span`
  display: block;
  padding: ${rem(16)};
  border-bottom: 1px solid ${sdsColor.border.defaultDefault};
  background: ${sdsColor.background.defaultSecondary};
`;

const HeaderTitle = styled.span`
  display: block;
  font-size: ${rem(14)};
  font-weight: 500;
  line-height: ${rem(16)};
  margin-bottom: ${rem(4)};
`;

const HeaderSubtitle = styled.span`
  display: block;
  font-size: ${rem(12)};
  font-weight: 500;
  line-height: ${rem(16)};
`;

const Content = styled.span`
  display: block;
  padding: ${rem(16)};
`;

const AudienceTitle = styled.span`
  display: block;
  font-size: ${rem(16)};
  font-weight: 600;
  line-height: ${rem(24)};
  margin-bottom: ${rem(8)};
`;

const SupportingText = styled.span`
  display: block;
  font-size: ${rem(12)};
  font-weight: 400;
  line-height: ${rem(16)};
`;

const TagList = styled.span`
  display: flex;
  flex-wrap: wrap;
  gap: ${rem(8)};
  margin: ${rem(12)} 0;
`;

const Tag = styled.span`
  align-items: center;
  background: ${sdsColor.background.defaultSecondary};
  border: 1px solid ${sdsColor.border.defaultDefault};
  border-radius: 100px;
  display: flex;
  gap: ${rem(4)};
  max-width: 100%;
  padding: ${rem(4)} ${rem(12)};
  user-select: none;
  font-size: ${rem(12)};
  font-weight: 500;
  line-height: ${rem(16)};
`;

const TagLabel = styled.span`
  color: ${sdsColor.text.defaultSecondary};
  text-transform: capitalize;
`;

const TagValue = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Highlight = styled.span`
  font-weight: 600;
`;

export default {
  AudienceTitle,
  Card,
  Content,
  ErrorText,
  Header,
  HeaderSubtitle,
  HeaderTitle,
  Highlight,
  Skeleton,
  SupportingText,
  Tag,
  TagLabel,
  TagList,
  TagValue
};
